import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../commonv3/api/RemoteResourceV3';
import { ExamWritingSectionShowView, WritingQuestionShowView } from '../../../types/exam_sections';
import { ExamWritingSectionId, CourseExamId } from '../../../../commonv3/types/courseExams';
import { WritingSectionAnswerState } from '../../../components/organisms/exam_sections/states/WritingSectionAnswerState';
import { SubmitState } from '../../../../commonv3/states/SubmitState';
import { ExamWritingSectionApis } from '../../../apis/examWritingSections';
import { WritingSectionSubmissionApis } from '../../../apis/writingQuestionSubmissions';
import { scrollToTop } from '../../../../mainv2/utils/scroll';

export class WritingSectionPageState {
    @observable sectionId: ExamWritingSectionId = null;
    @observable section: RemoteResourceV3<ExamWritingSectionShowView> = RemoteResourceV3.loading();
    @observable answerState = new WritingSectionAnswerState();
    @observable showScore = false;
    @observable writingSectionSubmissionCode = null;
    @observable submitState = new SubmitState();

    @action.bound
    async init(sectionId: ExamWritingSectionId) {
        this.sectionId = sectionId;
        const section = await this.reloadSection();
        this.answerState.init(section.questions);
    }

    @action.bound
    async reloadSection(): Promise<ExamWritingSectionShowView> {
        return await updateRemoteResourceV3(
            this.section,
            (v) => (this.section = v),
            () => ExamWritingSectionApis.show(this.sectionId)
        );
    }

    @action.bound
    async submitAndScore() {
        await this.submitState.operate(async () => {
            const answers = this.answerState.questions.map((q) => ({
                question_id: q.id,
                correct: this.answerState.getAnswerState(q).isCorrect(),
                answer: '',
            }));
            const request = { answers };
            const code = await WritingSectionSubmissionApis.create(this.sectionId, request);
            this.showScore = true;
            this.writingSectionSubmissionCode = code;
            scrollToTop();
        });
    }
}
